import replaceUrlToHttps from '../utils/replace-url-to-https';

/**
 * 处理微信分享下因为加入了微信自动在分享后边加上了query字符串而导致首次进入分享页会回首页而不是指定分享页面问题
 * 通过下面函数转存 hash 到 query string 中
 * @param {string} url - 解析url地址, 如: https://github.com/jeromeetienne/threex.cloudgaming#/detail
 * @returns {string}
 */
function convertHashIntoQueryString(url) {
  // noinspection JSUnresolvedVariable,ES6ModulesDependencies
  if (APP_SETTINGS.SHARE.storeHashToQueryString) {
    const a = document.createElement('a');
    a.href = url;
    a.search = '?__route_hash__=' + encodeURIComponent(a.hash);
    a.hash = '';
    return a.href;
  } else {
    return url;
  }
}

/**
 * 默认分享参数
 * @type {{link: string, shareImage: string, title: string, desc: string}}
 */
export const defaultShareParamsConfig = {
  title: document.title,
  desc: document.querySelector('meta[name=description]')?.content,
  link: convertHashIntoQueryString(replaceUrlToHttps(window.location.href)),
  shareImage: `https://${DEPLOY_HTTP_URL}favicon-200x200.png`
};

/**
 * 获取默认分享参数
 * 注意: 必须在 https 环境下才可以生效
 * @return {{title: string, $link: string, imgUrl: string, desc: string}}
 */
export default function getDefaultShareParams({
                                                title = defaultShareParamsConfig.title,
                                                desc = defaultShareParamsConfig.desc,
                                                link = defaultShareParamsConfig.link,
                                                shareImage = defaultShareParamsConfig.shareImage
                                              } = {}) {
  return {
    title: title,
    $link: link,
    imgUrl: shareImage,
    desc: desc
  };
}
